import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  useTheme,
} from '@mui/material';
import Image from 'next/image';
import { FC } from 'react';

import { AbgTypography, CloseIcon, mergeSx } from '@abg/kit-base';

import {
  closeIconStyling,
  dialogContentStyling,
  dialogStyling,
  dialogTitleStyling,
  iconWrapperStyling,
} from './AmazonSuccessModal.styling';
import { AmazonSuccessModalParams } from './types';

import AmazonLogo from './assets/AmazonLogo.svg';

export const AmazonSuccessModal: FC<AmazonSuccessModalParams> = ({
  onClose,
  title,
  description,
}) => {
  const theme = useTheme();

  return (
    <Dialog open data-testid="linked-success-modal" sx={dialogStyling}>
      <DialogTitle sx={dialogTitleStyling} data-testid="action-dialog-title">
        <Stack direction="row" justifyContent="space-between" flexGrow={1}>
          <AbgTypography variant="h6">{title}</AbgTypography>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={iconWrapperStyling}
          >
            <CloseIcon sx={closeIconStyling} />
          </IconButton>
        </Stack>
      </DialogTitle>

      <Divider />

      <DialogContent
        sx={mergeSx(dialogContentStyling)}
        data-testid="action-dialog-content"
      >
        <Stack direction="column" rowGap={3}>
          <Stack gap={2} direction="row">
            <Image
              data-testid="brand-logo"
              style={{ width: 'auto', height: 'auto' }}
              src={theme.brandAssets.logo}
              alt="brand-logo"
              width={0}
              height={0}
            />
            <Divider orientation="vertical" flexItem />
            <Image
              data-testid="amazon-logo"
              style={{ width: 'auto', height: 'auto' }}
              src={AmazonLogo}
              alt="amazon-logo"
              width={0}
              height={0}
            />
          </Stack>

          <AbgTypography variant="body1">{description}</AbgTypography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
